import React from 'react';
import styles from './footer.module.css';
import Skeleton from 'react-loading-skeleton';
import Link from 'next/link';
import { FooterRes, PageReference } from '../../typescript/response';
import Button from '../ui/button';
import Snipe from '../ui/snipe';
import Image from 'next/image';
import { getCachedAsset } from '../../helper/utils';

export function Footer({
  footer,
  navMenu,
}: {
  footer: FooterRes;
  navMenu: PageReference[];
}) {
  const isFormTechnologiesTaxonomy =
    footer?.taxonomies && footer?.taxonomies[0]?.term_uid === 'form_technologies';

  const numColumns = isFormTechnologiesTaxonomy ? 2 : 3;
  const itemsPerColumn = Math.ceil(navMenu.length / numColumns);

  const linkSections = Array.from({ length: numColumns }, (_, i) =>
    navMenu.slice(i * itemsPerColumn, i * itemsPerColumn + itemsPerColumn),
  );

  return (
    <>
      <Snipe key="snipe" snipe={footer.snipe} />
      <footer>
        <div className={styles.footer}>
          <section className={styles.container}>
            <div className={styles.rightColumn}>
              <div className={styles.logo}>
                {footer.logo ? (
                  <img
                    {...(footer.logo.$?.url as {})}
                    src={getCachedAsset(footer.logo.url, {width: 600, quality: 75})}
                    loading="lazy"
                    alt={footer.logo.description ?? 'Logo'}
                    title={footer.logo.title}
                    className={styles.brandmarkIcon}
                  />
                ) : (
                  <Skeleton width={100} />
                )}
                {/* <h5 className={styles.title} {...(footer.$?.contact_title as {})}>
                  {footer.contact_title}
                </h5> */}
              </div>
              {/* <div className={styles.body} {...(footer.$?.contact_description as {})}>
                {footer.contact_description}
              </div>
              <Button
                text={footer.contact_submit_text}
                showIcon
                propWidth="250px"
                propHeight="48px"
                propBackgroundColor="var(--primary-500)"
                propHoverBackgroundColor="transparent"
                propTextColor="var(--white)"
                link="/contact-us?form_type=Stay%20Connected"
              /> */}
            </div>

            <div className={styles.linksGrid}>
              {linkSections.map((section, sectionIndex) => (
                <div className={styles.links} key={sectionIndex}>
                  {section.map((navItem, index) => {
                    const href = `${navItem.page_reference?.[0]?.url ?? '/'}${
                      navItem.form_type ? `?form_type=${navItem.form_type}` : ''
                    }`;

                    return (
                      <div className={styles.footerLink} key={index}>
                        <Link
                          {...(navItem.$?.label as {})}
                          href={href}
                          className={styles.linkPrimary}
                        >
                          {navItem.label}
                        </Link>
                      </div>
                    );
                  })}
                </div>
              ))}
            </div>

            <div
              className={`${styles.social} ${
                isFormTechnologiesTaxonomy ? styles.socialFormTechnologies : ''
              }`}
            >
              {footer.right_column_title && (
                <span className={styles.rightColumnTitle}>{footer.right_column_title}</span>
              )}
              <div className={styles.socialIconWrapper}>
                {footer.social?.length > 0 &&
                  footer.social.map(social => (
                    <a
                      {...(social.link.$?.href as {})}
                      href={social.link.href}
                      title={social.link.title}
                      key={social.link.title}
                      className={styles.socialIconLink}
                    >
                      {isFormTechnologiesTaxonomy ? (
                        <Image
                          {...(social.image.$?.url as {})}
                          src={`${social.image.url}?width=194&height=56&auto=webp&fit=crop,smart`}
                          alt={social.image.description || social.link.title}
                          width={194}
                          height={56}
                          loading="lazy"
                          className={styles.socialIcon}
                        />
                      ) : (
                        <Image
                          {...(social.image.$?.url as {})}
                          src={`${social.image.url}?width=24&height=24&auto=webp&fit=crop,smart`}
                          alt={social.image.description || social.link.title}
                          width={24}
                          height={24}
                          loading="lazy"
                          className={styles.socialIcon}
                        />
                      )}
                    </a>
                  ))}
              </div>
            </div>
          </section>
        </div>
      </footer>
    </>
  );
}
